/* eslint-disable no-mixed-operators */
import React from 'react';
import {
  Grid,
  Header,
  Divider,
  Segment,
  Form,
  Input,
  List,
  Popup,
  Icon,
} from 'semantic-ui-react';
import _ from 'lodash';

const plans = [
  { key: '1', text: 'Small Business', value: 1 },
  { key: '5', text: 'Flat Rate', value: 5 },
  { key: '2', text: 'Business Elite', value: 2 },
];

const kgrams = [
  { key: '0', text: '0', value: 0 },
  { key: '1', text: '1', value: 1 },
  { key: '2', text: '2', value: 2 },
  { key: '3', text: '3', value: 3 },
  { key: '4', text: '4', value: 4 },
  { key: '5', text: '5', value: 5 },
  { key: '6', text: '6', value: 6 },
  { key: '7', text: '7', value: 7 },
  { key: '8', text: '8', value: 8 },
  { key: '9', text: '9', value: 9 },
  { key: '10', text: '10', value: 10 },
  { key: '11', text: '11', value: 11 },
  { key: '12', text: '12', value: 12 },
  { key: '13', text: '13', value: 13 },
  { key: '14', text: '14', value: 14 },
  { key: '15', text: '15', value: 15 },
  { key: '16', text: '16', value: 16 },
  { key: '17', text: '17', value: 17 },
  { key: '18', text: '18', value: 18 },
  { key: '19', text: '19', value: 19 },
  { key: '20', text: '20', value: 20 },
  { key: '21', text: '21', value: 21 },
  { key: '22', text: '22', value: 22 },
  { key: '23', text: '23', value: 23 },
  { key: '24', text: '24', value: 24 },
  { key: '25', text: '25', value: 25 },
];

const grams = [
  { key: '0', text: '0', value: 0 },
  { key: '100', text: '100', value: 100 },
  { key: '200', text: '200', value: 200 },
  { key: '300', text: '300', value: 300 },
  { key: '400', text: '400', value: 400 },
  { key: '500', text: '500', value: 500 },
  { key: '600', text: '600', value: 600 },
  { key: '700', text: '700', value: 700 },
  { key: '800', text: '800', value: 800 },
  { key: '900', text: '900', value: 900 },
];

class BusinessCalc extends React.Component {
  state = {
    planFid:
      (this.props.user.businessPricing &&
        this.props.user.businessPricing.planFid) ||
      2,
    itemPrice: 30,
    kg: 0,
    g: 500,
  };

  getShippingRate = (planFid) => {
    if (planFid === 1) {
      return 3.6;
    } else if (planFid === 2) {
      return 3.4;
    }

    return 4.2;
  };

  getFees = (planFid, price) => {
    if (planFid === 1) {
      return _.round(0.11 * price + 1, 2);
    } else if (planFid === 2) {
      return _.round(0.09 * price + 1, 2);
    }

    return 0;
  };

  render() {
    const { planFid, kg, g, itemPrice } = this.state;
    const price = parseFloat(itemPrice) || 0;

    const weight = (kg * 1000 + g) / 100;
    const shippingRate = this.getShippingRate(planFid);
    const shipping = weight * shippingRate;

    const fees = this.getFees(planFid, price);
    const totalUSD = _.round(price + shipping + fees, 2);
    const totalEGP = _.round(totalUSD * 20.0, 2);

    return (
      <Grid stackable centered>
        <Grid.Column width={8}>
          <Form>
            <Form.Group widths="equal">
              <Form.Select
                fluid
                label="Business Plan"
                options={plans}
                value={this.state.planFid}
                onChange={(e, data) => this.setState({ planFid: data.value })}
              />
            </Form.Group>

            <Form.Field>
              <label className="pullLeft" htmlFor="presentation">
                Item Price (USD)
              </label>
              <Input
                type="number"
                step="0.1"
                min="0"
                value={itemPrice}
                onChange={(e) => this.setState({ itemPrice: e.target.value })}
              />
            </Form.Field>

            <Form.Group widths="equal">
              <Form.Select
                fluid
                label="Item Weight (kilogram)"
                options={kgrams}
                value={kg}
                onChange={(e, data) => this.setState({ kg: data.value })}
              />
              <Form.Select
                fluid
                label="(gram)"
                options={grams}
                value={g}
                onChange={(e, data) => this.setState({ g: data.value })}
              />
            </Form.Group>
          </Form>
        </Grid.Column>

        <Grid.Column width={8}>
          {/* <Header>Item Cost</Header> */}
          <Segment>
            <Header size="small">Item Cost</Header>

            <List>
              <List.Item>
                <List.Content className="pullLeft">Item Price</List.Content>
                <List.Content className="pullRight">${price}</List.Content>
              </List.Item>

              <List.Item>
                <List.Content className="pullLeft">
                  International Shipping
                </List.Content>
                <List.Content className="pullRight">${shipping}</List.Content>
              </List.Item>

              <List.Item>
                <List.Content className="pullLeft">Service Fees</List.Content>
                <List.Content className="pullRight">${fees}</List.Content>
              </List.Item>

              <Divider />

              <List.Item>
                <List.Content className="pullLeft">Total is USD</List.Content>
                <List.Content className="pullRight">${totalUSD}</List.Content>
              </List.Item>

              <Divider />

              <List.Item>
                <List.Content className="pullLeft">
                  <b>
                    Total in EGP{' '}
                    <Popup
                      trigger={<Icon link name="info circle" />}
                      content="USD Exchange Rate: 20.0"
                      position="top center"
                    />
                  </b>
                </List.Content>
                <List.Content className="pullRight">
                  <Header size="small" style={{ color: '#B12704' }}>
                    {totalEGP} EGP
                  </Header>
                </List.Content>
              </List.Item>
            </List>
          </Segment>
        </Grid.Column>
      </Grid>
    );
  }
}

export default BusinessCalc;



// WEBPACK FOOTER //
// ./app/components/CalculatorModal/BusinessCalc.js